import {
  Button,
  Divider,
  IconButton,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useContext } from "react";
import logo from "./assets/logo.png";
import BGc from "./assets/homebg.png";
import logomain from "./assets/main-logo.png";
// import main from "./assets/main.png";
// import apes from "./assets/apes.png";
// import maleApe from "./assets/maleape.png";
// import femaleApe from "./assets/femaleape.png";
// import rightCloud from "./assets/maincloud-right.png";
// import leftCloud from "./assets/maincloud-left.png";
import leftPurpleCloud from "./assets/cloud-left.png";
import rightPurpleCloud from "./assets/cloud-right.png";

import Lh from "./assets/lh.png";
import Th from "./assets/th.png";
import { FaDiscord } from "react-icons/fa";
import { BsTwitter } from "react-icons/bs";
import CustomDrawer from "./CustomDrawer";
import "./Header.css";
import { MintNFT } from "../MintNFT/MintNFT";
import { AppContext } from "../../utils";
import { HashLink } from "react-router-hash-link";
function Navbar({ mintPage, openLogout, setopenLogout }) {
  // const [progesss, setProgress] = useState(false);
  const check = useMediaQuery("(max-width:1200px)");
  // const cloudImageHandleAtLg = useMediaQuery("(max-width:1300px)");
  // const hide = useMediaQuery("(max-width:600px)");

  // const { account, connect, disconnect } = useContext(AppContext);

  // const connectHanle = async () => {
  //   try {
  //     await connect();
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // const disconencttHanle = () => {
  //   disconnect();
  // };
  return (
    <div
      style={{
        background: "#0E072D",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        maxWidth="xl"
        // margin="auto"
        sx={{
          color: "white",
          paddingTop: "10px",
        }}
      >
        <Box width={check ? "90%" : "15%"} sx={{ marginLeft: "20px" }}>
          <img
            src={logo}
            alt=""
            style={{
              borderRadius: "50%",
            }}
          />
        </Box>

        {check ? (
          <>
            {" "}
            <CustomDrawer
              openLogout={openLogout}
              setopenLogout={setopenLogout}
            />{" "}
          </>
        ) : (
          <>
            <Box width="50%" mr="80px">
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Box
                  fontWeight="bold"
                  fontSize="15px"
                  lineHeight="24px"
                  sx={{
                    color: "#EF0C51",
                    "&:hover": {
                      color: "#F3ADB4",
                    },
                    "&:active": {
                      color: "white",
                    },
                    cursor: "pointer",
                  }}
                >
                  THE SOULMAPES
                </Box>
                <IconButton>
                  <HashLink
                    style={{ textDecoration: "none" }}
                    smooth
                    to="/#aboutus"
                  >
                    <Box
                      fontWeight="bold"
                      fontSize="15px"
                      lineHeight="24px"
                      color="white"
                      fontFamily="'Baloo Bhai 2', cursive"
                      sx={{
                        "&:hover": {
                          color: "#F3ADB4",
                          "&:active": {
                            color: "#E80937",
                          },
                        },
                      }}
                    >
                      ABOUT US
                    </Box>
                  </HashLink>
                </IconButton>
                <IconButton>
                  <HashLink
                    style={{ textDecoration: "none" }}
                    smooth
                    to="/#roadmap"
                  >
                    <Box
                      fontWeight="bold"
                      fontSize="15px"
                      lineHeight="24px"
                      color="white"
                      fontFamily="'Baloo Bhai 2', cursive"
                      sx={{
                        "&:hover": {
                          color: "#F3ADB4",
                          "&:active": {
                            color: "#E80937",
                          },
                        },
                      }}
                    >
                      ROADMAP
                    </Box>
                  </HashLink>
                </IconButton>
                <IconButton>
                  <HashLink
                    style={{ textDecoration: "none" }}
                    smooth
                    to="/#team"
                  >
                    <Box
                      fontWeight="bold"
                      fontSize="15px"
                      lineHeight="24px"
                      color="white"
                      fontFamily="'Baloo Bhai 2', cursive"
                      sx={{
                        "&:hover": {
                          color: "#F3ADB4",
                          "&:active": {
                            color: "#E80937",
                          },
                        },
                      }}
                    >
                      THE TEAM
                    </Box>
                  </HashLink>
                </IconButton>
                <IconButton>
                  <HashLink
                    style={{ textDecoration: "none" }}
                    smooth
                    to="/#freq"
                  >
                    <Box
                      fontWeight="bold"
                      fontSize="15px"
                      lineHeight="24px"
                      color="white"
                      fontFamily="'Baloo Bhai 2', cursive"
                      sx={{
                        "&:hover": {
                          color: "#F3ADB4",
                          "&:active": {
                            color: "#E80937",
                          },
                        },
                      }}
                    >
                      FAQ's
                    </Box>
                  </HashLink>
                </IconButton>
              </Stack>
            </Box>

            <Box width="10%">
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-evenly"
              >
                {/* {account ? (
                    <>
                      {" "}
                      <Button
                        onClick={() => {
                          setopenLogout(true);
                        }}
                        sx={{
                          color: "#F3ADB4",
                          border: "2px solid #F3ADB4",
                          borderRadius: "50px",
                          width: "125px",
                          height: "36px",
                          fontFamily: "'Baloo Bhai 2', cursive",
                          fontWeight: "600",
                          paddding: "10px",
                        }}
                      >
                        {account.slice(0, 10) + "....."}
                      </Button>{" "}
                    </>
                  ) : (
                    <>
                      {" "}
                      <Button
                        onClick={connectHanle}
                        sx={{
                          color: "#F3ADB4",
                          border: "2px solid #F3ADB4",
                          borderRadius: "50px",
                          width: "125px",
                          height: "36px",
                          fontFamily: "'Baloo Bhai 2', cursive",
                          fontWeight: "600",
                          paddding: "10px",
                        }}
                      >
                        connect
                      </Button>{" "}
                    </>
                  )} */}
                <a
                  style={{ textDecoration: "none", color: "white" }}
                  href=" https://discord.com/invite/soulmapes"
                  target="_blank"
                >
                  <Box
                    width="40px"
                    height="40px"
                    sx={{
                      "&:hover": {
                        background: "#101440",
                      },
                      backgroundColor: "#CF1B52",
                      borderRadius: "50px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FaDiscord
                      style={{
                        fontSize: "25px",
                      }}
                    />
                  </Box>
                </a>
                <a
                  style={{ textDecoration: "none", color: "white" }}
                  href="  https://twitter.com/soulmapes"
                  target="_blank"
                >
                  <Box
                    width="40px"
                    height="40px"
                    sx={{
                      "&:hover": {
                        background: "#101440",
                      },
                      backgroundColor: "#CF1B52",
                      borderRadius: "50px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <BsTwitter
                      style={{
                        fontSize: "25px",
                      }}
                    />
                  </Box>
                </a>
              </Stack>
            </Box>
          </>
        )}
      </Stack>
    </div>
  );
}

export default Navbar;
